const action = "SEGMENT_INFERENCE";
export const REQUEST = action+'_REQUEST';
export const RESPONSE = action+'_RESPONSE';
export const PENDING = action+'_PENDING';
export const CLEAR = action+'_CLEAR';
export const FAILURE = action+'_FAILURE';

export const segmentInferenceRequest = (payload) => {
    return {
        type: REQUEST,
        payload
    };
};

export const segmentInferenceSuccess = (response) => ({
  type: RESPONSE,
  payload: response
});

// Async path (foundation-direct): the server accepted the job and returned an
// inference_id; the actual forecast lands later via the realtime WebSocket
// ('inference.completed'). We keep the dialog in its loading state and stash
// the id so the deployment page can match the completion event.
export const segmentInferencePending = (payload) => ({
  type: PENDING,
  payload
});

export const clearInferenceState = () => ({
  type: CLEAR
});

export const segmentInferenceFailure = (error) => ({
  type: FAILURE,
  payload: error
});
